import { useState, useEffect } from 'react';
import styles from './About.module.css';

const text = "Every Moment Your Sight Captures Holds Hidden Value.";

const lines = text.split('<br>').map(line => line.trim().split(' '));
const totalWords = lines.reduce((acc, line) => acc + line.length, 0);

function About() {
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const start = window.innerHeight; 
      const end = 2 * window.innerHeight; 

      if (scrollTop < start) {
        setScrollProgress(0);
      } else if (scrollTop >= start && scrollTop < end) {
        setScrollProgress((scrollTop - start) / (end - start));
      } else {
        setScrollProgress(1);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const coloredCount = Math.floor(scrollProgress * totalWords);

  let currentIndex = 0;

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.textContainer}>
          <div className={styles.text}>
            {lines.map((line, lineIndex) => (
              <div key={lineIndex} className={styles.line}>
                {line.map((word, wordIndex) => {
                  const isColored = currentIndex < coloredCount; 
                  currentIndex++;
                  return (
                    <span
                      key={wordIndex}
                      className={isColored ? styles.colored : styles.normal}
                    >
                      {word}{' '}
                    </span>
                  );
                })}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;